
<!-- 简单表单类型 -->
<template>
  <el-form :rules="rules" :model="form" ref="ruleForm" class="addnew-from">
    <el-form-item
      v-for="item in raWData"
      :label="item.attrName"
      :prop="item.attr"
      :key="item.attr"
      label-width="140px"
      >
      <!-- 无编辑权限 -->
      <el-input
        v-if="item.attrVisible"
        value="* * * * * *"
        :disabled="true">
      </el-input>
      <!-- 普通文本框 -->
      <el-input
        :disabled="item.nonEditable"
        v-else-if="item.fieldType===1"
        :placeholder="item.placeholder"
        v-model="form[item.attr]">
      </el-input>
      <!-- 数字文本框 -->
      <el-input
        :disabled="item.nonEditable"
        v-else-if="item.fieldType===2"
        v-model.number="form[item.attr]"
        :placeholder="item.placeholder"
        @keyup.native="onInput(item)"
        @change="(value) => getPaymentMoney(value, item)"
        >
        <template
          v-if="item.unit"
          slot="append">{{item.unit}}
        </template>
      </el-input>
      <!-- 下拉选择框 自定义 -->
      <el-select clearable
        filterable
        :disabled="item.nonEditable"
        v-else-if="item.fieldType===3 && item.valueArrMap"
        v-model="form[item.attr]"
        :placeholder="item.placeholder"
        >
        <el-option
          v-for="arr in item.valueArrMap"
          :key="arr.key"
          :label="arr.value"
          :value="arr.key">
        </el-option>
      </el-select>
      <!-- 下拉选择框 普通 -->
      <el-select clearable
      filterable
        :disabled="item.nonEditable"
        :placeholder="item.placeholder"
        v-else-if="item.fieldType===3 && item.initValue"
        v-model="form[item.attr]">
          <el-option
            v-for="option in strToArr(item.initValue)"
            :key="option"
            :value="option">
          </el-option>
      </el-select>
      <!-- 日期选择 -->
      <el-date-picker
        :disabled="item.nonEditable"
        :editable="item.nonEditable"
        v-else-if="item.fieldType===4"
        type="date"
        placeholder="选择日期"
        value-format="yyyy-MM-dd"
        v-model="form[item.attr]"
      >
      </el-date-picker>
      <!-- 图片上传 -->
      <template v-else-if="item.fieldType===5 || item.fieldType===6">
        <v-upload
          :disabled="item.nonEditable"
          :attrValue="form[item.attr]"
          :defaultList = "item.attrValue"
          type="image">
        </v-upload>
      </template>
      <!-- 多行文本 -->
      <el-input
        :disabled="item.nonEditable"
        v-else-if="item.fieldType===7"
        type="textarea"
        v-model="form[item.attr]"
        :placeholder="item.placeholder"
        auto-complete="off">
      </el-input>
      <!-- 文件上传 -->
      <template v-else-if="item.fieldType===8">
        <v-upload
          :disabled="item.nonEditable"
          :attrValue="form[item.attr]"
          :defaultList="item.attrValue"
          type="file">
        </v-upload>
        <el-checkbox-group :value="form[item.attr]" v-show="false">
          <el-checkbox
            v-for="(file,index) in form[item.attr]"
            :key="file.attachIndex+index"
            :label="file.filename">
          </el-checkbox>
        </el-checkbox-group>
      </template>
      <!-- 多选框 -->
      <el-checkbox-group
        :disabled="item.nonEditable"
        v-else-if="item.fieldType===9"
        v-model="form[item.attr]">
        <el-checkbox
          v-for="(option, index) in strToArr(item.initValue)"
          :label="option"
          :key="index"
          :name="item.attr">
        </el-checkbox>
      </el-checkbox-group>
      <!-- 星星 -->
      <template v-else-if="item.fieldType===10">
        <el-rate
          style="padding-top: 7px"
          v-model="form[item.attr]">
        </el-rate>
        <el-input
          v-show="false"
          :value="form[item.attr]">
        </el-input>
      </template>
      <!-- 回款状态及归属人 -->
      <payment-status
        v-else-if="item.attr === 'status'"
        ref="contractApi"
        :payMethodArray="payMethodArray"
        :item="item"
        :form="form"
        >
      </payment-status>
    </el-form-item>
  </el-form>
</template>
<script>
import Vue from 'vue'
import { Message } from 'element-ui'
import { mapGetters, mapActions } from 'vuex'
import Birthday from 'components/fieldtype/date-birthday'
import vUpload from 'components/fieldtype/upload'
import paymentStatus from 'components/fieldtype/payment/payment-status'

// 自定义校验规则
const checkDate = (rule, value, callback) => {
  if (!value) {
    return callback(new Error())
  }
  callback()
}

const checkNumber = (rule, value, callback) => {
  if (value === '' && rule.required) {
    return callback(new Error(`请输入${rule.attrName}`))
  }
  // 小数位超出提示
  if (value.toString().indexOf('.') !== -1 && value.toString().split('.')[1].length > rule.num) {
    console.log('rule', rule)
    return callback(new Error(`该字段限制小数位数不能大于${rule.num}`))
  }

  if (value && isNaN(value)) {
    return callback(new Error('请输入正确的数字类型'))
  }
  callback()
}

export default {
  created () {
    this.initAddnew()
  },
  props: {
    paymentData: {
      type: Array,
      default: () => []
    },
    payMethodArray: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  name: 'addNewForm',
  data () {
    return {
      raWData: [], // 获取到的原始数据
      rules: {}, // 校验规则
      form: {}
    }
  },
  computed: {
    ...mapGetters([
      'isCheckPayment',
      'paymentForm',
      'addPaymentData',
      'editPaymentData'
    ])
  },
  mounted () {
  },
  methods: {
    ...mapActions([
      'setPaymentForm',
      'checkPayment',
      'setEditPaymentMoney'
    ]),
    // 初始化
    initAddnew () {
      this.raWData = JSON.parse(JSON.stringify(this.paymentData))
      this.setDate()
      this.setRules()
    },
    // 设置初始值
    setDate () {
      this.raWData.forEach((obj) => {
        if (obj.fieldType === 10) {
          Vue.set(this.form, obj.attr, Number(obj.attrValue))
        } else if (obj.fieldType === 2) {
          Vue.set(this.form, obj.attr, obj.attrValue === '' ? '' : Number(obj.attrValue))
        } else if (obj.fieldType === 4) {
          Vue.set(this.form, obj.attr, obj.attrValue || (!obj.isRedundant ? utils.formatDate() : ''))
        } else if (obj.fieldType === 9) {
          Vue.set(this.form, obj.attr, obj.attrValue ? obj.attrValue.split('|') : [])
        } else if ([5, 6, 8].indexOf(obj.fieldType) > -1) {
          if (!obj.attrValue) {
            obj.attrValue = '[]'
          }
          Vue.set(this.form, obj.attr, JSON.parse(obj.attrValue))
        } else {
          Vue.set(this.form, obj.attr, obj.attrValue)
        }
      })
    },
    // 设置验证规则
    setRules () {
      this.raWData.forEach((obj) => {
        // 字符串
        if (obj.required && [1, 7].indexOf(obj.fieldType) > -1) {
          Vue.set(this.rules, obj.attr, { required: true, message: `请输入${obj.attrName}`, trigger: 'blur' })
          // 数字
        } else if (obj.fieldType === 2) {
          Vue.set(this.rules, obj.attr, { validator: checkNumber, attrName: obj.attrName, required: !!obj.required, num: obj.decimalPrecision, trigger: 'change' })
          // 日期
        } else if (obj.fieldType === 4 && obj.required) {
          Vue.set(this.rules, obj.attr, { validator: checkDate, required: true, message: `请选择${obj.attrName}`, trigger: 'change' })
          // 数组
        } else if ([5, 6, 8, 9].indexOf(obj.fieldType) > -1 && obj.required) {
          Vue.set(this.rules, obj.attr, { required: true, type: 'array', message: `请选择${obj.attrName}`, trigger: 'change' })
          // 星星
        } else if (obj.fieldType === 10 && obj.required) {
          Vue.set(this.rules, obj.attr, { validator: this.checkStar, message: `请选择${obj.attrName}`, required: true, trigger: 'change' })
        } else if (obj.required) {
          Vue.set(this.rules, obj.attr, { required: true, type: obj.validate || 'string', message: `请选择${obj.attrName}`, trigger: 'change' })
        }
      })
    },
    strToArr (str) {
      if (str) {
        return str.split('|')
      }
      return []
    },
    // 格式化要提交的数据
    formatData () {
      let defaultData = {}
      let redundantData = {}

      this.raWData.forEach((item) => {
        // 如果是多选类型，先将数组转为字符串再保存
        if (item.fieldType === 9) {
          let value = this.form[item.attr]
          let formatCheckbox = value ? value.join('|') : value
          Vue.set(item.isRedundant ? redundantData : defaultData, item.attr, formatCheckbox)
        } else {
          if (item.attr === 'status' && this.form[item.attr] === '2') {
            Vue.set(defaultData, 'belonger', this.form.belonger[0])
            Vue.set(defaultData, 'payMethod', this.form.payMethod)
          }
          Vue.set(item.isRedundant ? redundantData : defaultData, item.attr, (this.form[item.attr] !== undefined) ? this.form[item.attr] : '')
        }
      })
      Vue.set(defaultData, 'id', this.raWData[0].id || 0)
      return {'defaultData': defaultData, 'redundantData': redundantData}
    },
    // 提交前校验表单
    handleSubmit () {
      let isHandle = true
      if (this.paymentForm.length > 1) {
        this.paymentForm.map((item) => {
          if (item.defaultData.paymentNo === this.form.paymentNo) {
            Message({
              type: 'error',
              message: '回款计划编号重复'
            })
            isHandle = false
            return
          }
        })
      }
      if (isHandle) {
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            this.paymentForm.push(this.formatData())
            this.setPaymentForm(this.paymentForm)
          } else {
            Message({
              type: 'error',
              message: '输入有误，请检查后重新提交！'
            })
          }
        })
      } else {
        this.checkPayment(false)
      }
    },
    // 超出小数位的处理
    onInput (item) {
      var value = this.form[item.attr].toString()
      if (value.indexOf('.') !== -1) {
        var precisionLen = value.split('.')[1].length // 获取input输入小数位的长度
        if (precisionLen > item.decimalPrecision) {
          setTimeout(() => {
            // 如果小数位超出，则保留有效小数位
            this.form[item.attr] = value.substr(0, value.indexOf('.') + item.decimalPrecision + 1)
          }, 1500)
        }
      }
    },
    // 验证星星
    checkStar (rule, value, callback) {
      if (!value || value < 1) {
        callback(new Error())
      } else {
        callback()
      }
    },
    getPaymentMoney (value, item) {
      if (item.id && item.attr === 'amount') {
        this.setEditPaymentMoney({id: item.id, money: value})
      }
    },
    checkpaymentStatus (rule, value, callback) {
      if (!value) {
        callback(new Error(`请选择回款状态`))
      } else if (!this.form.belonger) {
        callback(new Error(`请选择归属人`))
      } else if (!this.form.payMethod) {
        callback(new Error(`请选择支付方式`))
      }
    }
  },
  filters: {
    arrToStr (arr) {
      return arr.join(',')
    }
  },
  watch: {
    isCheckPayment (val) {
      if (val) {
        if (this.disabled) {
          let isHandle = true
          this.paymentForm.map((item) => {
            if (item.defaultData.paymentNo === this.form.paymentNo) {
              isHandle = false
              return
            }
          })
          if (isHandle) {
            this.paymentForm.push(this.formatData())
            this.setPaymentForm(this.paymentForm)
          }
        } else {
          this.handleSubmit()
        }
      }
    }
  },
  components: {
    paymentStatus,
    Birthday,
    vUpload
  }
}
</script>

<style lang="less">
  .addnew-from {
    .el-form-item.is-error .el-input__inner {
      border-color: #f56c6c !important;
    }
    .el-form-item.is-required .el-form-item__label:before {
      content: '';
      color: #fff;
    }
    .el-form-item.is-required >.el-form-item__label:before {
      content: '*';
      color: #f56c6c;
      margin-right: 4px;
    }
    .el-checkbox-group {
      .el-checkbox {
        margin: 0 30px 0 0;
      }
      .el-checkbox__label {
        white-space: initial;
      }
    }
  }
</style> 

<style lang="less" scoped>
.addnew-from {
  margin-right: 50px;
  padding-top: 18px;
}
</style> 



// WEBPACK FOOTER //
// add-new-form.vue?388a09b4